import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const TestimonialCard = ({ 
  name, 
  role, 
  company, 
  content, 
  avatar, 
  rating = 5,
  delay = 0 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay }}
      viewport={{ once: true }}
      className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 relative"
    >
      <Quote className="w-8 h-8 text-primary/20 absolute top-6 right-6" />
      
      <div className="flex items-center mb-4">
        {[...Array(rating)].map((_, i) => (
          <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
        ))}
      </div>
      
      <p className="text-gray-600 mb-6 leading-relaxed italic">
        "{content}"
      </p>
      
      <div className="flex items-center">
        <div className="w-12 h-12 bg-gradient-to-br from-primary to-blue-600 rounded-full flex items-center justify-center text-white font-semibold mr-4">
          {avatar ? (
            <img src={avatar} alt={name} className="w-12 h-12 rounded-full object-cover" />
          ) : (
            name.charAt(0)
          )}
        </div>
        <div>
          <h4 className="font-semibold text-secondary">{name}</h4>
          <p className="text-sm text-gray-500">{role} at {company}</p>
        </div>
      </div>
    </motion.div>
  );
};

export default TestimonialCard;
